import type { DataFeedProviderType, TradingProviderType, CountryProviders, ProviderInfo } from './types';
import { DATA_FEED_PROVIDERS } from './dataFeedProviders';
import { TRADING_PROVIDERS } from './tradingProviders';

// Mapping of countries to available providers
export const PROVIDERS_BY_COUNTRY: CountryProviders = {
    'IN': {
        dataFeed: ['kite'],
        trading: ['kite','papertrade']
    },
};

// Helper functions to get available providers by country
export function getAvailableDataFeedProviders(country: string): ProviderInfo[] {
    const providers = PROVIDERS_BY_COUNTRY[country];
    const providerTypes = providers.dataFeed.length>0 ? [ ...providers.dataFeed] : [];
    return providerTypes.map(type => DATA_FEED_PROVIDERS[type as DataFeedProviderType]);
}

export function getAvailableTradingProviders(country: string): ProviderInfo[] {
    const providers = PROVIDERS_BY_COUNTRY[country];
    const providerTypes = providers.trading.length>0 ? [ ...providers.trading] : [];
    return providerTypes.map(type => TRADING_PROVIDERS[type as TradingProviderType]);
}
